module.exports = __webpack_public_path__ + "assets/pdf/2014-08_bloomberg.pdf";